var e={props:{icon:{required:!0,type:String},title:{required:!1,default:null}}};export{e as default};
